// The account-setup wizard's steps, as GET /api/account-setup/status reports them:
// 1 Your details, 2 Ad accounts, 3 Choose a plan, 4 Connect your site (added 2026-09-28 for
// every account). The server counts a skipped step as done and decides what counts as a
// connected site, so these only read its flags.
const STEP_FLAGS = ['step1_complete', 'step2_complete', 'step3_complete', 'step4_complete'];

export const SETUP_STEP_COUNT = STEP_FLAGS.length;

/** The step to resume at (1-4), or null when setup is finished. */
export const nextSetupStep = (status) => {
  const index = STEP_FLAGS.findIndex((flag) => !(status && status[flag]));
  return index === -1 ? null : index + 1;
};

export const setupStepsRemaining = (status) => STEP_FLAGS.filter((flag) => !(status && status[flag])).length;
